import styles from './ReportTrend.module.css';
import Label from '../UI/Label';
import { ReactComponent as DownIcon } from '../../assets/images/underPerforming.svg';
import { ReactComponent as UpIcon } from '../../assets/images/bestPerforming.svg';

interface ReportTrendProps {
	status: string;
}

const ReportTrend = (props: ReportTrendProps) => {
	return (
		<div className={styles.container}>
			{props.status === 'up' ? (
				<UpIcon className={styles.iconOrange} />
			) : (
				<DownIcon className={styles.iconGreen} />
			)}
			<Label
				className={props.status === 'up' ? styles.orange : styles.green}
				text={'Trend'}
			/>
		</div>
	);
};

export default ReportTrend;
